import Breadcrumb from "Components/Common/Breadcrumb";
import React from "react";
import { Container } from "reactstrap";
function DashboardCards() {
  document.title = "Ditobanx";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Dashboards" breadcrumbItem="Cards" />
          <h4>Cards</h4>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default DashboardCards;
